export default "__VITE_ASSET__f6999dcf__"